import { render, staticRenderFns } from "./thirdParty.vue?vue&type=template&id=532e96a2&"
import script from "./thirdParty.vue?vue&type=script&lang=js&"
export * from "./thirdParty.vue?vue&type=script&lang=js&"
import style0 from "./thirdParty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports